<template>
	<div v-if="context" id="results">
		<nk-wrapper spacing="lg">
			<nk-template-wegweiser-abc :context="context" :options="options" />
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateWegweiserUebersicht',

	mixins: [TemplatesDefault],
};
</script>
